import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const FormW9 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Request Form W-9 Online for Free with TaxZerone"
          description="Easily request, manage, and store Form W-9 from vendors with TaxZerone’s secure platform. Save time and reduce errors. Get started for free!"
          keywords=""
          canonical="request-form-w9-online-free/"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="166"
        />
      }
    >
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Request{' '}
                <span className="highlight-container">
                  <span className="highlight">W9 Form</span>
                </span>{' '}
                Online for{' '}
                <span className="highlight-container">
                  <span className="highlight">Free</span>
                </span>{' '}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Request the taxpayer identification number (TIN) from recipients
                online for free to ensure accurate 1099 filings at the year-end.
                TaxZerone helps businesses securely collect W-9 information from
                vendors, contractors, and freelancers in a fast and paperless
                way.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 2 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w9`}
                  sx={{
                    mt: { xs: 4, md: 4 },
                    fontSize: '22px !important',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Request W-9 for FREE
                </Button>
                <Button
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    px: 5,
                    mt: { xs: 4, md: 4 },
                    border: '2px solid rgb(29, 169, 74)',
                    borderRadius: 6,
                    color: 'rgb(29, 169, 74)',
                    fontSize: '24px',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  // className="btn-primary"
                  // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                >
                  Learn how it works
                </Button>
                {/* <Hidden mdDown>
                <Box sx={{}}>
                  <picture>
                    <source
                      srcSet="/assets/images/irs-authorized.webp"
                      //  className="mw-100"
                      width={70}
                      height={69}
                    />
                    <source
                      srcSet="/assets/images/irs-authorized.png"
                      //  className="mw-100"
                      width={70}
                      height={69}
                    />
                    <img
                      src="/assets/images/irs-authorized.png"
                      loading="lazy"
                      alt="IRS-authorized e-file provider"
                      //  className="mw-100"
                      width={70}
                      height={69}
                    />
                  </picture>
                </Box>
              </Hidden> */}
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w9-tax-form.webp" />
                <source srcSet="/assets/images/w9-tax-form.png" />
                <img
                  src="/assets/images/w8ben-landing-img.png"
                  alt="Request Free Form W-8BEN Online"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w8ben-landing-img-sm.webp" />
                <source srcSet="/assets/images/w8ben-landing-img-sm.png" />
                <img
                  src="/assets/images/w8ben-landing-img-sm.png"
                  alt="Request Free Form W-8BEN Online"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is a Form W-9?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Form W-9 (Request for Taxpayer Identification Number and
                  Certification) is an IRS form use to collect a payee's name,
                  address, and Taxpayer Identification Number (TIN) — such as an
                  SSN or EIN — before making reportable payments. The payer can
                  use this information to prepare Form 1099 for tax reporting
                  purposes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Example:
                </Typography>

                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -6 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      If a business hires an independent contractor for
                      services, it may request a Form W-9 to collect the
                      contractor’s details before{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-nec/"
                        sx={{ color: '#0202ff' }}
                      >
                        filing Form 1099-NEC
                      </Link>
                      .
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -6 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      If a business makes payments such as rent, royalties, or
                      other miscellaneous income, it may request a Form W-9 to
                      collect the recipient&apos;s details before{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-misc/"
                        sx={{ color: '#0202ff' }}
                      >
                        filing Form 1099-MISC
                      </Link>
                      .
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -6 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      If a company pays dividends or distributions to
                      shareholders, it may request a Form W-9 to collect the
                      recipient’s tax details before{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-div/"
                        sx={{ color: '#0202ff' }}
                      >
                        filing Form 1099-DIV
                      </Link>
                      .
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-is-form-w9-img.webp" />
                  <source srcSet="/assets/images/what-is-form-w9-img.png" />
                  <img
                    src="/assets/images/what-is-form-w9-img.png"
                    alt="What is Form W-9?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={380}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Who needs to provide a W-9?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 0,
                  maxWidth: '600px',
                  mx: 'auto',
                  textAlign: 'center',
                }}
              >
                If you're making payments that will require a 1099, you need
                their W-9 form. Here's exactly who that covers.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/freelancers-contractors-img.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/freelancers-contractors-img.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/cpeos-icon.png"
                      alt="CPEOs"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Freelancers & Contractors
                </Typography>
                <Typography variant="body1">
                  Providing services to a business for $600 or more in a tax
                  year triggers a{' '}
                  <Link
                    href="/resources/information-returns/form-1099-nec-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    1099-NEC
                  </Link>{' '}
                  requirement — and a W-9 first.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vendors-suppliers-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vendors-suppliers-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vendors-suppliers-icon.png"
                      alt="Vendors & Suppliers"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Vendors & Suppliers
                </Typography>
                <Typography variant="body1">
                  Any vendor receiving reportable payments from a business
                  customer should submit a W-9 before invoicing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/landlords-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/landlords-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/landlords-icon.png"
                      alt="Landlords"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Landlords
                </Typography>
                <Typography variant="body1">
                  Landlords receiving rent payments through property management
                  companies typically need to provide a W-9.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/investment-income-recipients-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/investment-income-recipients-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/investment-income-recipients-icon.png"
                      alt="Investment Income Recipients"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Investment Income Recipients
                </Typography>
                <Typography variant="body1">
                  Recipients of interest (
                  <Link
                    href="/resources/information-returns/form-1099-int-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    1099-INT
                  </Link>
                  ) , dividends (
                  <Link
                    href="/resources/information-returns/form-1099-div-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    1099-DIV
                  </Link>
                  ), or broker proceeds ({' '}
                  <Link
                    href="/resources/information-returns/form-1099-b-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    1099-B
                  </Link>
                  ) all require a w9 on file.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/partnerships_img.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/partnerships_img.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/partnerships-img.png"
                      alt=" partnerships_img"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  LLCs & Partnerships
                </Typography>
                <Typography variant="body1">
                  Flow-through entities entering business relationships where
                  payments will be reported need to complete a W-9 as an entity
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 51, height: 54 }}>
                    <source
                      srcSet="/assets/images/not-for-employees-img.webp"
                      width={60}
                      height={54}
                    />
                    <source
                      srcSet="/assets/images/not-for-employees-img.png"
                      width={51}
                      height={54}
                    />
                    <img
                      src="/assets/images/not-for-employees-img.png"
                      alt=" not-for-employees-img"
                      loading="lazy"
                      width={51}
                      height={54}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Not for Employees
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="/resources/information-returns/form-w-2-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    W-2
                  </Link>{' '}
                  employees complete Form W-4, not W-9. The key difference:
                  employers withhold payroll taxes from employees; W-9 payees
                  handle their own.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={4}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  // mr: { xs: 0, md: 0 },
                  // maxHeight: 432,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-information-are-recipients-w9.webp" />
                  <source srcSet="/assets/images/what-information-are-recipients-w9.png" />
                  <img
                    src="/assets/images/what-information-are-recipients-w9.png"
                    alt="What Information Are Recipients Required to Provide on Form W-9?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={500}
                    // height="{auto}"
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What information are recipients required to provide on Form
                  W-9?
                </Typography>

                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Personal information-
                          </span>

                          <Box
                            component="ul"
                            sx={{ mt: 1, mb: 0, '& li': { mb: 0.5 } }}
                          >
                            <li>Enter your Individual or entity’s name.</li>
                            <li>
                              Business name or disregarded entity name (if
                              applicable).
                            </li>
                          </Box>
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Federal Tax Classification –
                          </span>{' '}
                          Select the appropriate tax classification,
                          <Box
                            component="ul"
                            sx={{ mt: 1, mb: 0, '& li': { mb: 0.5 } }}
                          >
                            <li>Individual/Sole Proprietor,</li>
                            <li>C Corporation,</li>
                            <li>S Corporation,</li>
                            <li>Partnership,</li>
                            <li>Trust/Estate,</li>
                            <li>
                              LLC, or Other (C Corporation, S Corporation,
                              Partnership)
                            </li>
                          </Box>
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>Exemptions –</span>{' '}
                          Enter any applicable exempt payee code or FATCA
                          reporting exemption code, if eligible.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Address Details –
                          </span>{' '}
                          Provide your current street address, city, state, and
                          ZIP code.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Account Number(s) (Optional) –
                          </span>{' '}
                          Include any account number(s) associated with the
                          request, if applicable.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Taxpayer Identification Number (TIN) –
                          </span>{' '}
                          Enter your Social Security Number (SSN), Employer
                          Identification Number (EIN), or Individual Taxpayer
                          Identification Number (ITIN), as applicable.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem disablePadding alignItems="flex-start">
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Certification –
                          </span>{' '}
                          Sign and date the form to certify the accuracy of your
                          information, confirm your TIN, and meet IRS
                          certification requirements.
                        </>
                      }
                    />
                  </ListItem>
                </List>
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w9`}
                  sx={{
                    mr: { xs: 0, md: 0 },
                    mb: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Fill Form W-9
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Streamline Your W-9 Process with TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Collecting W-9 forms can be a hassle, but not with TaxZerone.
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Our online platform makes it easy to request, collect, and
                manage W-9s.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/w9-steps-img.webp"
                  className="img-responsive"
                  width={640}
                  height={540}
                />
                <source
                  srcSet="/assets/images/w9-steps-img.png"
                  className="img-responsive"
                  width={640}
                  height={540}
                />
                <img
                  src="/assets/images/w9-steps-img.png"
                  alt="Streamline Your W-9 Process with TaxZerone"
                  className="img-responsive"
                  loading="lazy"
                  width={640}
                  height={540}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                How it works:
              </Typography>
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Send W-9 Requests"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography variant="body1">
                      <b>Step 1: Send W-9 Requests: </b> <br />
                      Easily send secure W-9 requests to your vendors through
                      TaxZerone. They&apos;ll receive an email with a simple
                      link to fill out the form.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Vendor Fills Out W-9"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography variant="body1">
                      <b> Step 2: Vendor Fills Out W-9:</b> <br />
                      Your vendors can easily fill out the W-9 form with their
                      information, including name, address, and taxpayer
                      identification number (TIN).
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Instant Notifications"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography variant="body1">
                      <b>Step 3: Instant Notifications:</b> <br />
                      Receive instant notifications when your vendors complete
                      and submit their W-9 forms. Access all completed forms
                      conveniently within your TaxZerone account.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
          backgroundColor: '#f0f2f9',
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What if you don’t receive a W-9 from a Recipient?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Without valid recipient information, you may be unable to
                  properly file tax forms such as Form 1099-NEC or Form
                  1099-MISC. It leads to:
                </Typography>

                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -12 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      <span style={{ fontWeight: 600 }}>
                        Backup withholding Obligations:
                      </span>{' '}
                      If a payee does not provide a valid Taxpayer
                      Identification Number (TIN) or correct taxpayer
                      information, you may be required to withhold{' '}
                      <span style={{ fontWeight: 600 }}>24%</span> of certain
                      reportable payments and remit that amount to the IRS until
                      valid information is received.
                    </ListItemText>
                  </ListItem>

                  <ListItem
                    disablePadding
                    sx={{
                      mb: 1,
                      '&.MuiListItem-root': { alignItems: 'center' },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -6 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      <span style={{ fontWeight: 600 }}>
                        IRS Penalties and Notices:
                      </span>{' '}
                      Failure to collect accurate taxpayer information may
                      result in penalties, notices, or additional compliance
                      issues for the business.
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'center' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-if-you-dont-receive-a-w-9-img.webp" />
                  <source srcSet="/assets/images/what-if-you-dont-receive-a-w-9-img.png" />
                  <img
                    src="/assets/images/what-if-you-dont-receive-a-w-9-img.png"
                    alt="What is Form 941?"
                    loading="lazy"
                    width="100%"
                    height="auto"
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          // backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Tired of Manual W-9 collection from Recipients
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  mx: 'auto',
                  maxWidth: { sm: '80%', xs: 'auto' },
                  textAlign: 'center',
                }}
              >
                Stop wasting time chasing recipients for W-9 forms through
                paperwork. TaxZerone simplifies W-9 collection with secure
                online requests, faster responses, and easy form management.
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Requests"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk W-9 requests
                </Typography>
                <Typography variant="body1">
                  Send W-9 requests to multiple recipients at once. Save hours
                  during vendor onboarding season.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={55}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={55}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Real-time Notifications"
                      loading="lazy"
                      width={55}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy and Secure Process
                </Typography>
                <Typography variant="body1">
                  Streamline your Form W-9 requests with TaxZerone’s intuitive
                  and secure online platform.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/sign-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/sign-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/sign-icon.png"
                      alt="E-signature Built-in"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  E-signature Built-in
                </Typography>
                <Typography variant="body1">
                  Recipient sign their W-9 electronically through a ZeroneVault
                  — no downloads, no printing, no scanning. Fully compliant with
                  IRS e-signature requirements.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="Easy E-Signature"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  W-9 to 1099 Automation
                </Typography>
                <Typography variant="body1">
                  Data flows directly from collected W-9s into your 1099 forms.
                  Reduce manual re-entry errors and file 1099s with one click
                  when the tax year closes
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/automate-w-9-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/automate-w-9-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/automate-w-9-icon.png"
                      alt="Automate W-9 to 1099 processing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  TIN Validation
                </Typography>
                <Typography variant="body1">
                  TaxZerone verifies the TIN provided matches IRS records,
                  catching mismatches before they trigger backup withholding or
                  IRS notices.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Customer Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Dedicated Support
                </Typography>
                <Typography variant="body1">
                  Reach our support team by phone, email, or live chat. Get
                  answers about W-9 requirements, form completion, or account
                  setup.
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 12 }}
              sx={{
                justifyContent: 'center',
                textAlign: 'center',
                alignItems: 'center',

                margin: 'auto',
              }}
            >
              <Box
                sx={{
                  textAlign: { xs: 'center', sm: 'center', md: 'center' },
                  justifyContent: 'center',
                  margin: 'auto',
                }}
              >
                <Typography variant="body1" sx={{ mt: 5 }}>
                  Choose TaxZerone for a simplified, secure, and accurate Form
                  W-9 request process{' '}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    textAlign: 'center',
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w9`}
                >
                  Fill Form W-9
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                W-9 vs. 1099 vs. W-2 vs. W-8
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                These forms work together but serve very different purposes.
                Here's how they relate.
              </Typography>

              <TableContainer
                sx={{
                  border: '1px solid #828282',
                  mb: 4,
                  maxWidth: 950,
                  m: 'auto',
                }}
              >
                <Table aria-label="W-9 vs Other Tax Forms">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#ccc', fontWeight: 600 }}>
                      <TableCell
                        sx={{
                          color: '#444',
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Form
                      </TableCell>

                      <TableCell
                        sx={{
                          color: '#444',
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Purpose
                      </TableCell>

                      <TableCell
                        sx={{
                          color: '#444',
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Who completes it
                      </TableCell>

                      <TableCell
                        sx={{
                          color: '#444',
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Filed to IRS
                      </TableCell>

                      <TableCell
                        sx={{
                          color: '#444',
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Results
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell sx={{ fontWeight: 600 }}>W-9</TableCell>
                      <TableCell>
                        Collect payee&apos;s TIN and details
                      </TableCell>
                      <TableCell>Payee (contractor, vendor)</TableCell>
                      <TableCell>No — kept by requester</TableCell>
                      <TableCell>Accurate 1099 filing</TableCell>
                    </TableRow>

                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell sx={{ fontWeight: 600 }}>1099</TableCell>
                      <TableCell>Report income paid to the payee</TableCell>
                      <TableCell>Payer (business) and individual</TableCell>
                      <TableCell>Yes</TableCell>
                      <TableCell>Payee&apos;s tax return obligation</TableCell>
                    </TableRow>

                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell sx={{ fontWeight: 600 }}>W-2</TableCell>
                      <TableCell>
                        Report wages and withheld taxes for employees
                      </TableCell>
                      <TableCell>Employer</TableCell>
                      <TableCell>Yes</TableCell>
                      <TableCell>Employee&apos;s tax return</TableCell>
                    </TableRow>

                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell sx={{ fontWeight: 600 }}>W-4</TableCell>
                      <TableCell>Instruct employer on withholding</TableCell>
                      <TableCell>Employee</TableCell>
                      <TableCell>No — kept by employer</TableCell>
                      <TableCell>Correct paycheck withholding</TableCell>
                    </TableRow>

                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell sx={{ fontWeight: 600 }}>
                        W-8 (BEN/BEN-E)
                      </TableCell>
                      <TableCell>
                        Certify foreign status and claim treaty benefits
                      </TableCell>
                      <TableCell>Non-U.S. persons/entities</TableCell>
                      <TableCell>No — kept by withholding agent</TableCell>
                      <TableCell>Reduced/exempt U.S. withholding</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          background: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                Trusted by accounting professionals and business owners
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  mb: { xs: 1, sm: 3 },
                  mx: 'auto',
                  maxWidth: { sm: '70%', xs: 'auto' },
                }}
              >
                Real feedback from accounting professionals, business owners,
                and payroll managers who collect W-9s with TaxZerone.
              </Typography>

              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
                sx={{ mb: 3 }}
              >
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                      minHeight={{ xs: 'auto', sm: 'auto', md: 200, lg: 200 }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        We onboard dozens of contractors each quarter. TaxZerone
                        cut our W-9 collection time from weeks to days. The bulk
                        request feature alone is worth it.
                        <Stack
                          component="span"
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Maria Johnson
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ textAlign: 'right', maxWidth: '200px', ml: 'auto' }}
                    >
                      AP Manager, Mid-size Construction Firm
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                      minHeight={{ xs: 'auto', sm: 'auto', md: 200, lg: 200 }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        The TIN validation caught three mismatches before we
                        filed our 1099s. That alone saved us from IRS notices.
                        The W-9 to 1099 automation is seamless.
                        <Stack
                          component="span"
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      -James Taylor
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{ textAlign: 'right', maxWidth: '200px', ml: 'auto' }}
                    >
                      CPA, Independent Tax Practice
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                      minHeight={{ xs: 'auto', sm: 'auto', md: 200, lg: 200 }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I was nervous about moving our W-9 collection online but
                        the SOC 2 certification and the secure portal made the
                        decision easy for our compliance team.
                        <Stack
                          component="span"
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      -Tara Williams
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ textAlign: 'right', maxWidth: '200px', ml: 'auto' }}
                    >
                      Controller, Tech Startup
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Start collecting W-9s today-for free
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mb: 2,
            mx: 'auto',
            maxWidth: { sm: '50%', xs: 'auto' },
          }}
        >
          Join thousands of businesses that have replaced manual W-9 collection
          with TaxZerone's secure, automated platform.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w9`}
          >
            Get Started Today!
          </Button>
        </Box>
      </Box>

      <Container maxWidth="lg" component="section" aria-labelledby="w9-faqs">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="w9-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is Form W-9 and who needs to fill it out?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text" sx={{ mt: 1 }}>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w9`}
                      sx={{ color: '#0202ff' }}
                    >
                      Form W-9
                    </Link>{' '}
                    is an IRS document used to collect a payee&apos;s Taxpayer
                    Identification Number (TIN) and certification of tax status.
                    It&apos;s completed by independent contractors, vendors,
                    freelancers, landlords, and investment income
                    recipients—anyone receiving reportable payments from a payer
                    who needs to{' '}
                    <Link href="/form-1099-series/" sx={{ color: '#0202ff' }}>
                      file a 1099 forms
                    </Link>
                    . Employees fill out a W-4 instead.
                  </Typography>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What happens if don&apos;t submit a W-9?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text" sx={{ mt: 1 }}>
                    If you refuse to provide a W-9 , the payer is required by
                    the IRS to apply backup withholding at 24% on your payments
                    and send that amount to the IRS. You&apos;ll eventually be
                    able to recover it via your tax return, but it delays your
                    full payment unnecessarily.
                  </Typography>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What are the 2026 changes to Form W-9?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text" sx={{ mt: 1 }}>
                    A new exempt payee category for digital asset (DA) brokers
                    was added, along with a new certification checkbox in Part
                    II for inter-broker digital asset reporting.
                  </Typography>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What is the new digital asset (DA) exempt recipient
                  category on Form W-9?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text" sx={{ mt: 1 }}>
                    The IRS added a new exempt payee category specifically for
                    U.S. digital asset (DA) brokers. Under Regulations section
                    1.6045-1(c)(3)(i)(B)(12), a broker that qualifies as a U.S.
                    digital asset broker—as defined in Reg. section
                    1.6045-1(g)(4)(i)(A)(1)—is now an exempt recipient for
                    purposes of sales of digital assets. Importantly, this
                    exemption does not apply to registered investment advisers
                    that don&apos;t otherwise qualify as exempt recipients under
                    clauses (B)(1) through (B)(11) of the same regulation. This
                    change is detailed in IRS Notice 2024-56
                  </Typography>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What is the new broker certification checkbox in Part II of
                  W-9 form?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text" sx={{ mt: 1 }}>
                    The updated Form W-9 added a checkbox in Part II
                    (Certification) that allows one broker to certify to another
                    broker that it is a U.S. digital asset broker within the
                    meaning of Regulations section 1.6045-1(g)(4)(i)(A)(1) and
                    qualifies as an exempt recipient under Reg. section
                    1.6045-1(c)(3)(i)(B)(12). This checkbox supports compliance
                    with IRS inter-broker digital asset reporting rules under
                    Notice 2024-56, allowing brokers to formally document their
                    exempt status when transacting digital assets with each
                    other.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. How does TaxZerone use W-9 data to file 1099s?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text" sx={{ mt: 1, mb: 2 }}>
                    Once a vendor submits their W-9 through TaxZerone, the
                    information—name, TIN, address, and tax classification—is
                    stored securely and pre-populates your{' '}
                    <Link href="/form-1099-series/" sx={{ color: '#0202ff' }}>
                      1099 forms
                    </Link>{' '}
                    at year end.
                  </Typography>
                  <Alert
                    icon={false}
                    severity="warning"
                    sx={{
                      mt: 0,
                      borderLeft: '3px solid rgb(102, 60, 0)',
                    }}
                  >
                    <b>Note :</b> TaxZerone also validates TINs against IRS
                    records to catch mismatches before you file, preventing
                    backup withholding notices and IRS penalties.
                  </Alert>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-w9/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW9;
